import { useState } from "react";
import { importApi } from "../services/import.api";
import { TImportsFilterState } from "../store/importsSlice";
import toast from "react-hot-toast";
import { getErrorFromCatch, serializeFieldErrors } from "../services/api";

export default function useTracking(initImportsFilter?: Partial<TImportsFilterState>) {
  const [loading, setLoadingVal] = useState<boolean>(false);
  const setLoading = () => setLoadingVal(() => true); 
  const unsetLoading = () => setLoadingVal(() => false); 
  
  // --
  // -- Updating tracking list
  // --
  const [updateTrackingApi] = importApi.useUpdateTrackingMutation();
  const updateTrackingHandle = async (): Promise<number> => {
    setLoading();

    try {
      const response = await updateTrackingApi({}).unwrap();     
      if (response?.count === undefined) throw new Error(`Failed to set tasks into the Tracking Queue`); 
      toast.success(`${response.count} tasks have been set to the Tracking Queue successfully`);
      return response.count;
    } catch (err) {      
      toast.error(`${getErrorFromCatch(err)}`, { duration: 8000 });           
      return 0;
    } finally {
      unsetLoading();
    }    
  };

  // --
  // -- Updating tracking list
  // --
  const [launchQueueApi] = importApi.useLaunchQueueMutation({})
  const launchQueueHandle = async (): Promise<boolean> => {
    setLoading();

    try {
      await launchQueueApi({}).unwrap();    
      toast.success(`The Tracking Queue has been launched successfully`);
      return true;
    } catch (err) {
      toast.error(`${getErrorFromCatch(err)}`, { duration: 8000 });           
      return false;
    } finally {
      unsetLoading();
    }    
  };

  return {
    loading,
    setLoading,
    unsetLoading,

    updateTrackingHandle,
    launchQueueHandle,
  };
};
